import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    token: '',
    isLogged: false,
    loading: true, 
    owner: {},
    authorities: []
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setToken(state, action) {
            state.token = action.payload || '';
            state.isLogged = !!action.payload; 
            state.loading = false; 
        },
        setOwner(state, action) {
            state.owner = action.payload || {};
        },
        setAuthorities(state, action) {
            state.authorities = action.payload || [];
        },
        setLoading(state, action) {
            state.loading = action.payload; 
        },
    },
});

export const { setToken, setOwner, setAuthorities, setLoading } = authSlice.actions;
export default authSlice.reducer;